<div class="layout__main-modal">
  <div class="main__modal-header">
    <button
      class="close"
      mat-icon-button
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <h3 class="modal-heading">Reject document</h3>
  </div>
  <div
    mat-dialog-title
    class="dialog-title"
  >
    <div class="title">Are you sure you want to reject this document?</div>
  </div>
  <mat-dialog-content class="dialog-content">
    <div class="message">If you have any issue for signing this document, please feel free to let us know. Thank you!</div>
    <mat-form-field class="w-full">
      <mat-label>Reason</mat-label>
      <textarea
        matInput
        maxlength="512"
        [(ngModel)]="reason"
        placeholder="Enter your reason"
      >
      </textarea>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button
      mat-button
      type="button"
      class="cancel margin-right-40 text-black bg-[#F3F4F9]"
      (click)="close()"
    >
      Cancel
    </button>
    <button
      class="submit"
      mat-button
      class="cimb-button--primary"
      (click)="submit()"
    >
      Submit
    </button>
  </mat-dialog-actions>
</div>
